/**
 * Parcels Receipt
 */

// React
import React, {useEffect} from 'react';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {Store} from '../../../redux/reducers';
import {createPostOrderAction} from '../../orders/actions';

// Selector
import {createStructuredSelector} from 'reselect';

//UI
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';

import {WrapperReceipt} from './style';
import jMoment from 'moment-jalaali';

// Helper
import {
  formaterPhoneNumber,
  translateInsuranceType,
  translateOrderStatus, translateParcelType,
  translateServiceType,
} from '../../../utils/helpers';

// Type
import {SelectorProps, Props} from './interfaces';
import {
  makeSelectOrder,
  makeSelectLoading,
  makeSelectError,
  makeSelectPostOrder,
} from '../../orders/selectors';
import {Payload} from '../../orders/interfaces';
import Barcode from "react-barcode";

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(-8),
        },
      },
    },
  })
);

export function Details(props: Props) {
  const classes = useStyles();

  useEffect(() => {
    const {id} = props.match.params;
    props.createPostOrderDispatch({
      id,
      body: {
        send: true
      }
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (props.postOrder.id) {
      window.print();
    }
  }, [props.postOrder])

  return (
    <WrapperReceipt className={classes.root}>
      <div className="page">
        <div className="logo-box">
          <div>
            <img src="/logo-dark.svg" alt="logo" />
          </div>
        </div>

        <div className=" wrapper ">
          {/*Section 1 */}
          <div
            className="flex"
            style={{
              marginBottom: '15px',
            }}
          >
            <div style={{width: '100%'}}  className="flex flex-column">
              <div style={{width: '100%'}} className="flex justify-content-between align-items-center title">
                <span>{'صورت حساب پست'}</span>
                <Barcode height={'30px'} fontSize={9} value={props.postOrder.barcode} />
              </div>
              <div className="flex justify-content-between">
                <div className="flex">
                  <span className="label"> تاریخ ثبت:</span>
                  <span className="bold">
                    {' '}
                    {props.postOrder.registrationDate &&
                      `${jMoment(props.postOrder.registrationDate, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD')}`}
                  </span>
                </div>
                <div className="flex">
                  <span className="label"> تاریخ تحویل:</span>
                  <span className="bold">
                    {' '}
                    {props.postOrder.deliveryDate &&
                      `${jMoment(props.postOrder.deliveryDate, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD')}`}
                  </span>
                </div>
              </div>
            </div>
            <div className="flex-1"/>
          </div>

          {/* Section 2 */}
          <div className="card-a">
            <div className="card-a_box">
              <div className="card-a_item">
                <div className="card-a_label"> نام سفارش دهنده </div>
                <div className="card-a_text"> {props.postOrder.customerName}</div>
              </div>
              <div className="card-a_item">
                <div className="card-a_label"> شماره موبایل </div>
                <div className="card-a_text">
                  {formaterPhoneNumber(props.postOrder?.customerPhoneNumber)}
                </div>
              </div>
              <div className="card-a_item">
                <div className="card-a_label"> تاریخ تحویل سفارش </div>
                <div className="card-a_text">
                  {props.postOrder.deliveryDate &&
                  jMoment(props.postOrder.deliveryDate)
                    .locale('fa')
                    .format('YYYY/MM/DD HH:mm:ss')}
                </div>
              </div>
              <div className="card-a_item">
                <div className="card-a_label"> وضعیت تحویل </div>
                <div className="card-a_text">
                  {' '}
                  {translateOrderStatus(props.postOrder.status)}{' '}
                </div>
              </div>
            </div>
          </div>

          {/* Section 2 continue */}
          <div className="card-a">
            <div className="card-a_box">
              <div className="card-a_item">
                <div className="card-a_label">استان </div>
                <div className="card-a_text"> {props.postOrder.customerProvince}</div>
              </div>
              <div className="card-a_item">
                <div className="card-a_label"> شهر </div>
                <div className="card-a_text">{props.postOrder?.customerCity}</div>
              </div>
              <div className="card-a_item">
                <div className="card-a_label"> کد پستی </div>
                <div className="card-a_text">
                  {props.postOrder.customerZipCode && props.postOrder.customerZipCode}
                </div>
              </div>
            </div>
          </div>

          {/* Section 3 */}
          <div className="card-a">
            <div className="card-a_box">

              <div className="card-a_item">
                <div className="card-a_label"> آدرس سفارش دهنده </div>
                <div className="card-a_text">
                  {props.postOrder.customerAddress && props.postOrder.customerAddress}{' '}
                </div>
              </div>
            </div>
          </div>

          {/* Section 3 */}
          <div className="title" style={{marginTop: '15px'}}>
            مشخصات پستی
          </div>

          <div className="card-b">
            <div className="card-b_box">
              <div className="card-b_header-box">
                <div className="card-b_header">
                  <div className="card-b_header-item">نوع ارسال</div>
                  <div className="card-b_header-item">نوع بیمه</div>
                  <div className="card-b_header-item">سرویس پیامک</div>
                  <div className="card-b_header-item">نوع بسته</div>
                  {/* <div className="card-b_header-item">تعدادکارتن</div> */}
                  {/* <div className="card-b_header-item">نوع کارتن</div> */}
                  <div className="card-b_header-item">وزن دقیق</div>
                </div>
              </div>
              <div className="card-b_content">
                <div className="card-b_content-row">
                  <div className="card-b_content-item">{translateServiceType(props.postOrder.serviceType)}</div>
                  <div className="card-b_content-item">
                    {translateInsuranceType(props.postOrder.insuranceType)}
                  </div>
                  <div className="card-b_content-item">{props.postOrder.smsService ? 'بلی' : 'خیر'}</div>
                  <div className="card-b_content-item">{translateParcelType(props.postOrder.parcelType)}</div>
                  <div className="card-b_content-item">{props.postOrder.weight}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Section 4 */}
          <div className="title" style={{marginTop: '15px'}}>
            محاسبه هزینه
          </div>

          <div className="card-b">
            <div className="card-b_box">
              <div className="card-b_header-box">
                <div className="card-b_header">
                  <div className="card-b_header-item">عنوان هزینه</div>
                  <div className="card-b_header-item">مبلغ</div>
                </div>
              </div>
              <div className="card-b_content">
                <div className="card-b_content-row">
                  <div className="card-b_content-item">{'کرایه پست'}</div>
                  <div className="card-b_content-item">
                    {props.postOrder.postFare}
                  </div>
                </div>
                <div className="card-b_content-row">
                  <div className="card-b_content-item">{'هزینه پست'}</div>
                  <div className="card-b_content-item">
                    {props.postOrder.postPrice}
                  </div>
                </div>
                <div className="card-b_content-row">
                  <div className="card-b_content-item">{'مالیات'}</div>
                  <div className="card-b_content-item">
                    {props.postOrder.tax}
                  </div>
                </div>
                <div className="card-b_content-row">
                  <div className="card-b_content-item">{'مجموع'}</div>
                  <div className="card-b_content-item">
                    {props.postOrder.totalPrice}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Section 5 */}
          <div className="title" style={{marginTop: '15px'}}>
            توضیحات
          </div>

          <div className="description"/>
        </div>
      </div>
    </WrapperReceipt>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  order: makeSelectOrder(),
  postOrder: makeSelectPostOrder(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    createPostOrderDispatch: (payload: Payload) =>
      dispatch(createPostOrderAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Details);
